import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../utils/ajax'

class EAtalsBigPic {
  // 数据
  @observable loading
  @observable path

  constructor () {
    this.loading = false
    this.path = ''
  }

  @action
  getImgSrc = async(id,index,imgIndex) => {
    runInAction(()=>{
      this.loading = true
    })
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/content/catalogIdQueryAllContent?id=${id}`)
    if(res && res.status === 0){
      return
    }
    runInAction(()=>{
      this.path  = res[index].image.split(',')[imgIndex]
      this.loading = false
    })
  }
}

export default new EAtalsBigPic()


// WEBPACK FOOTER //
// ./src/project/dongfeng/eAtlas/EAtalsBigPic/store.js